@if(isLoading){
<div class="reserve-loading-container">
  <img
    width="28"
    height="28"
    src="assets/img/img-loadingAI.png"
    alt="Loading Image"
    class="loading-image"
  />
  <h2>資料送出中</h2>
  <!--  動畫 圓點 -->
  <div class="dot-loader">
    <span></span>
    <span></span>
    <span></span>
  </div>
</div>
}
@else{

<div class="card-content">
    <div class="" style="display: flex; justify-content: space-between; align-items: center;margin-bottom: 20px;">
        @if (getWorkloadTitle(questionnaireTypeId)) {
        <app-tag size="md" color="filled-gray">
            <app-text>{{ getWorkloadTitle(questionnaireTypeId) }}</app-text>
        </app-tag>
        }
        <div class="group-meta" style="display: flex;margin-bottom:10px;flex-direction: row-reverse;color: #97ADC4;">


            {{
            groupIndex + 1 }} / {{
            groupCount }} 題</div>
    </div>
    <div class="" *ngIf="cardIndex === 4 && card4GroupTitles[groupIndex]">
        <div class="line-title">
            {{ card4GroupTitles[groupIndex].title }}
        </div>
        <p class="line-subtitle">
            {{ card4GroupTitles[groupIndex].subtitle }}
        </p>
    </div>
    @if (questionnaireTypeId === '2' && groupIndex === 0) {
    <div class="instruction-image-block" style="text-align: center; margin-bottom: 20px;">
        <img src="assets/img/illustrate.svg" alt="說明圖" style="max-width: 100%; border-radius: 8px;">
    </div>
    }
    @if (questionnaireTypeId === '2' && groupIndex === 5){
    <app-body-pain-selector></app-body-pain-selector>
    }
    @else{

    <div *ngFor="let q of questions; let i = index" class="question-block" style="margin-bottom: 20px;"
        [formGroup]="answerGroups[i]">
        <!-- 套用健檢表顯示規則 -->
        @if (answerGroups[i]){
        @if(shouldShowInput(q)) {
        @if (q.questionName.includes('___')) {
        <label class="input-title input-text-required" style="display: flex; align-items: center; flex-wrap: wrap;">
            <span>{{ q.questionName.split('___')[0] }}</span>
            <!-- input欄位使用 -->
            <input type="text" *ngIf="q.questionType === '1'"
                style="width: 120px; margin: 0 8px; text-align: center; outline: none;"
                (blur)="getChoiceId(q.choiceList[0]?.choiceId, answerGroups[i])" formControlName="answer"
                [class.invalid]="answerGroups[i]?.get('answer')?.invalid && answerGroups[i]?.get('answer')?.touched"
                [placeholder]="'請輸入'" />
            <!-- radioButton欄位使用 -->
            <mat-radio-group id="status" *ngIf="q.questionType === '3'" formControlName="answer" class="radio-group"
                style="display:initial">

                <div *ngFor="let c of q.choiceList" class="choice-item">
                    <div class="input-block">
                        <mat-radio-button class="radio-button-box" [value]="c.sortNo"
                            (change)="getChoiceId(c.choiceId, answerGroups[i])"
                            [class.invalid]="answerGroups[i]?.get('answer')?.invalid && answerGroups[i]?.get('answer')?.touched">
                            <label class="input-title" style="color:#333333" for="status">
                                {{ c.choiceName || c.description}}
                            </label>
                        </mat-radio-button>
                    </div>
                </div>
            </mat-radio-group>
            <!-- number欄位使用 -->
            <input type="number" *ngIf="q.questionType === '10'||q.questionType === '9'"
                style="width: 15%; margin: 0 8px; display: inline-block;  text-align: center;"
                (blur)="getChoiceId(q.choiceList[0]?.choiceId, answerGroups[i])" formControlName="answer"
                [class.invalid]="answerGroups[i]?.get('answer')?.invalid && answerGroups[i]?.get('answer')?.touched"
                [placeholder]="questionPlaceholders[q.questionId] || '請輸入'" />
            <span>{{ q.questionName.split('___')[1] }}</span>

        </label>
        }
        @else {
        <label class="input-title input-text-required">{{ q.questionName }}</label>
        <div class="input-block" style="margin-top: 10px;">
            <div class="input-group">
                <input *ngIf="q.questionType === '1' && shouldShowInput(q)" type="text"
                    (blur)="getChoiceId(q.choiceList[0]?.choiceId, answerGroups[i])" formControlName="answer"
                    [class.invalid]="answerGroups[i]?.get('answer')?.invalid && answerGroups[i]?.get('answer')?.touched"
                    [placeholder]="questionPlaceholders[q.questionId] || '請輸入'" />
            </div>

        </div>
        <!-- radioButton欄位使用 -->
        <mat-radio-group id="status" *ngIf="q.questionType === '3' && shouldShowInput(q)" formControlName="answer"
            class="radio-group" style="display:initial">
            <div *ngFor="let c of q.choiceList" class="choice-item">
                <div class="input-block">
                    <mat-radio-button class="radio-button-box" [value]="c.sortNo"
                        (change)="getChoiceId(c.choiceId, answerGroups[i])"
                        [class.invalid]="answerGroups[i]?.get('answer')?.invalid && answerGroups[i]?.get('answer')?.touched">
                        <label class="input-title" style="color:#333333" for="status">
                            {{ c.choiceName || c.description}}
                        </label>
                    </mat-radio-button>
                </div>
            </div>
        </mat-radio-group>
        }

        @if (q.questionType === '1' && answerGroups[i]?.get('answer')?.invalid &&
        answerGroups[i]?.get('answer')?.touched) {
        <mat-error class="input-error-msg" style="display: block; margin-top: 5px;">
            @for (errKey of getErrorKeys(answerGroups[i].get('answer')); track errKey) {
            <div>
                {{ getErrorMessage(q, errKey) }}
            </div>
            }
        </mat-error>
        }
        @if ((q.questionType === '10'||q.questionType === '9') && answerGroups[i]?.get('answer')?.invalid &&
        answerGroups[i]?.get('answer')?.touched) {
        <mat-error class="input-error-msg" style="display: block; margin-top: 5px;">
            @for (errKey of getErrorKeys(answerGroups[i].get('answer')); track errKey) {
            <div>
                {{ questionErrorMessages[q.questionId] ? questionErrorMessages[q.questionId][errKey] : '此欄位有誤' }}
            </div>
            }
        </mat-error>
        }
        }


        <div *ngIf="q.questionType === '3'&&!q.questionName.includes('行業')&&q.questionId !== 528" class="radio-group">
            <label class="input-title input-text-required" style="font-size:18px"> {{ q.questionName.includes('.')
                ? q.questionName.split('.').slice(1).join('.')
                : q.questionName
                }}</label>
            @if (answerGroups[i]?.get('answer')?.invalid && answerGroups[i]?.get('answer')?.touched) {
            <br>
            <mat-error class="input-error-msg">
                請選擇一個選項
            </mat-error>
            }

            <mat-radio-group id="status" formControlName="answer" class="radio-group" style="display:initial">
                <div *ngFor="let c of q.choiceList" class="choice-item">
                    <div class="input-block">
                        <mat-radio-button class="radio-button-box" [value]="c.sortNo"
                            (change)="getChoiceId(c.choiceId, answerGroups[i])"
                            [class.invalid]="answerGroups[i]?.get('answer')?.invalid && answerGroups[i]?.get('answer')?.touched">
                            <span class="input-title"
                                style="pointer-events: none; display: inline-block; color:#333333">
                                {{ c.choiceName || c.description}}
                            </span>
                        </mat-radio-button>
                    </div>
                </div>
            </mat-radio-group>
        </div>
        <div *ngIf="q.questionType === '3'&&q.questionName.includes('行業')" class="text">
            <label class="input-title input-text-required" style="font-size:18px"> {{ q.questionName }}</label>
            <br>
            @if (answerGroups[i]?.get('answer')?.invalid && answerGroups[i]?.get('answer')?.touched) {
            <mat-error class="input-error-msg">
                請選擇一個選項
            </mat-error>
            }
            <div class="input-block">
                <div class="input-group">

                    <mat-form-field appearance="fill" class="input-group">
                        <mat-select formControlName="answer"
                            (selectionChange)="getChoiceIdBySortNo($event.value, answerGroups[i], q)"
                            [placeholder]="'請輸入'">
                            @for (c of q.choiceList; track c) {
                            <mat-option [value]="c.sortNo">{{ c.choiceName}}</mat-option>
                            }
                        </mat-select>
                    </mat-form-field>

                </div>
            </div>
        </div>
        <!-- 日期選擇 -->
        <div *ngIf="q.questionType === '7'||q.questionType === '8'" class="text">
            <label class="input-title input-text-required" style="font-size:18px"> {{ q.questionName }}</label>
            <br>
            @if (answerGroups[i]?.get('answer')?.invalid && answerGroups[i]?.get('answer')?.touched) {
            <mat-error class="input-error-msg">
                請選擇一個選項
            </mat-error>
            }
            <div class="input-calculator-block" style="flex-direction:column">
                <div class="input-group input-btn-right">
                    <input id="answer" readonly appDateInput matInput [matDatepicker]="picker" placeholder="請輸入日期"
                        formControlName="answer"   [max]="today" (dateChange)="onDateChange($event, answerGroups[i], q)" />
                    <mat-datepicker-toggle [for]="picker" class="input-date-btn">
                        <ng-container matDatepickerToggleIcon>
                            <img src="assets/img/i-calendar.svg" alt="" />
                        </ng-container>
                    </mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </div>

                <div class="input-group input-btn-right">
                </div>
            </div>
            @if (q.questionId === 526) {
            <div style="margin-top: 8px;">
                <mat-checkbox formControlName="untilNow" (change)="onUntilNowChange($event.checked, answerGroups[i])">
                    至今為止
                </mat-checkbox>
            </div>
            }
        </div>

        <!-- textarea輸入區 -->
        <div *ngIf="q.questionType === '2'" class="text">
            <label class="input-title input-text-required" style="font-size:18px"> {{ q.questionName }}</label>
            <br>
            @if (answerGroups[i]?.get('answer')?.invalid && answerGroups[i]?.get('answer')?.touched) {
            <mat-error class="input-error-msg">
                請選擇一個選項
            </mat-error>
            }
            <div class="input-block">
                <div class="input-group">
                    <textarea rows="3" (blur)="getChoiceId(q.choiceList[0]?.choiceId, answerGroups[i])"
                        formControlName="answer"
                        [class.invalid]="answerGroups[i]?.get('answer')?.invalid && answerGroups[i]?.get('answer')?.touched"
                        [placeholder]="'請輸入其他症狀、病史說明'"
                        style="width: 100%; padding: 8px; border-radius: 8px; border: 1px solid  #d9d9d8;height:300px;margin-top: 20px;"></textarea>


                </div>
            </div>
        </div>
        <div *ngIf="(q.questionType === '9' || q.questionType === '10')&&!canShowHobbyInput" class="text">

            <label class="input-title input-text-required" style="font-size:18px">
                @if (q.questionName.includes('___')) {
                <span>{{ q.questionName.split('___')[0] }}</span>

                <input type="number" style="width: 15%; margin: 0 8px; display: inline-block;  text-align: center;"
                    (blur)="getChoiceId(q.choiceList[0]?.choiceId, answerGroups[i])" formControlName="answer"
                    [class.invalid]="answerGroups[i]?.get('answer')?.invalid && answerGroups[i]?.get('answer')?.touched"
                    [placeholder]="q.choiceList[0]?.description || '請輸入'" />

                <span>{{ q.questionName.split('___')[1] }}</span>
                } @else {
                {{ q.questionName }}
                }
            </label>


            @if (!q.questionName.includes('___')) {
            <div class="input-block">
                <div class="input-group">
                    <input type="number" (blur)="getChoiceId(q.choiceList[0]?.choiceId, answerGroups[i])"
                        formControlName="answer"
                        [class.invalid]="answerGroups[i]?.get('answer')?.invalid && answerGroups[i]?.get('answer')?.touched"
                        [placeholder]="questionPlaceholders[q.questionId] || '請輸入'" />
                </div>

                @if (hasInvalid || (answerGroups[i]?.get('answer')?.invalid && answerGroups[i]?.get('answer')?.touched))
                {
                <mat-error class="input-error-msg" style="display: block; margin-top: 5px;">
                    @for (errKey of getErrorKeys(answerGroups[i].get('answer')); track errKey) {
                    <div>
                        {{ getErrorMessage(q, errKey) }}
                    </div>
                    }
                </mat-error>
                }
            </div>
            }
        </div>
        <div>
            <div *ngIf="q.questionType === '4'">
                <div class="question-container" style="margin-bottom: 20px;">
                    <label class="input-title input-text-required">{{  q.questionName.split('.')[1] ?? q.questionName }}</label>

                    @if (answerGroups[i]?.get('answer')?.invalid && answerGroups[i]?.get('answer')?.touched) {

                    <mat-error class="input-error-msg" style="display: flex;flex-direction: column;">
                        請選擇一個選項
                    </mat-error>
                    }
                </div>
                <section class="mat-mdc-checkbox-group"
                    [class.input-error]="answerGroups[i]?.get('answer')?.invalid && answerGroups[i]?.get('answer')?.touched">

                    <div class="checkbox-wrapper">
                        <!-- 以下皆無：獨立一列 -->
                        <div class="none-option" *ngIf="getNoneOption(q) as noneOption">
                            <mat-checkbox [checked]="isChecked(noneOption.choiceId, answerGroups[i])"
                                (change)="onNoneChange($event.checked, noneOption.choiceId, answerGroups[i], q)">
                                {{ noneOption.choiceName }}
                            </mat-checkbox>
                        </div>
                        @if (getNormalOptions(q).length > 0&&getNoneOption(q)) {
                        <hr />
                        }
                        <!-- 其他選項 -->
                        <div class="checkbox-grid">
                            @for (c of getNormalOptions(q); track c.choiceId) {
                            <mat-checkbox [checked]="isChecked(c.choiceId, answerGroups[i])"
                                [disabled]="isNoneSelected(answerGroups[i], q)"
                                (change)="onCheckboxChange($event.checked, c.choiceId, answerGroups[i],q)">
                                {{ c.choiceName }}
                            </mat-checkbox>
                            }

                        </div>
                    </div>
                </section>
            </div>
        </div>
        }
    </div>
    }
</div>

<div class="page-btn-block">
    @if (groupIndex > 0) {
    <button mat-button class="btn-outline-primary btn-size-l" (click)="prevQuestion()">
        上一步
    </button>
    }
    @if (groupIndex < groupCount - 1) { <button mat-button class="btn-fill-primary btn-size-l" (click)="nextQuestion()">
        下一步
        </button>
        }
        @else{
        <button mat-button class="btn-fill-primary btn-size-l" (click)="submit()">
            送出
        </button>
        }

</div>

}